type PlayerEventMessage = {
    type: 'ODIA_PLAYER_EVENT';
    event: string;
    playerMode: string,
    languageCode: string;
    articleName: string;
    articleDuration: number;
    cursorPosition: number;
    previousCursorPosition?: number;
    playlistId?: string;
};


export const sendPlayerEvent = (
    eventsEnabled: boolean,
    event: string,
    playerMode: string,
    articleName: string,
    articleDuration: number,
    languageCode: string,
    cursorPosition: number,
    previousCursorPosition?: number,
    playlistId?: string
): void => {
    if (!eventsEnabled) return;
    if (typeof window === 'undefined') return;

    // send event to parent iframe only if it exists
    const isInIframe = window.self !== window.top;
    if (!isInIframe) return;

    const message: PlayerEventMessage = {
        type: 'ODIA_PLAYER_EVENT',
        event,
        playerMode,
        articleName,
        languageCode,
        articleDuration,
        cursorPosition,
        previousCursorPosition,
        playlistId
    };

    window.parent.postMessage(message, '*'); // optionally replace '*' with known parent origin

}